module.exports = __webpack_public_path__ + "static/img/content-3.64a662e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/content-3.png
// module id = f6Gi
// module chunks = 1